const languageModal = document.querySelector('.language-modal');
if (languageModal) {
  const toggleLanguageModal = (toggle) => {
    languageModal.classList.toggle('hide', toggle);
    document.body.classList.toggle('body-scroll-locked', !toggle);
    document.body.classList.toggle('lang-modal-open', !toggle);
    document.body.classList.add('language-selected', !toggle);

    // Handle inert outside modal
    document.querySelectorAll('body > *:not(.language-modal)').forEach((el) => {
      el.inert = !toggle;
    });
  };

  // Axios call for redirect if necessary
  const AxiosLanguageModal = (lang) => {
    grecaptcha.ready(async () => {
      const action = 'languageModal';
      const token = await grecaptcha.execute(localData.captchaSiteKey, { action });
      const formDataInput = {
        action,
        selection: lang,
        lang: localData.lang,
        id: localData.id,
        token,
      };
      const axiosResponse = await axios.post(localData.siteURL, formDataInput, {});
      if (axiosResponse.data.data.url) {
        window.location.href = axiosResponse.data.data.url;
      }
      toggleLanguageModal(true);
    });
  };

  const selectButton = document.querySelector('.language-modal .btn--default');
  selectButton.addEventListener('click', (ev) => {
    const dropdown = languageModal.querySelector('.dropdown');
    const dropdownSelection = dropdown.querySelector('input:checked');
    AxiosLanguageModal(dropdownSelection.id);
    ev.preventDefault();
  });

  // Open Modal
  attachEvent('.site-header__language-btn', 'click', (ev) => {
    toggleLanguageModal(false);
    ev.preventDefault();
  });

  // Close Modal
  attachEvent('.language-modal__overlay,.language-modal__close', 'click', (ev) => {
    toggleLanguageModal(true);
    ev.preventDefault();
  });

  // Close Modal on ESC key press
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      toggleLanguageModal(true);
    }
  });
}
